export const logoutHelper = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("expiresIn");
  localStorage.removeItem("permissions");
};

export const loginHelper = data => {
  const { user, token, clientUserProfilePicture, clientProfilePicture } = data;
  const { accessToken } = token;
  const { expiresIn } = token;
  localStorage.setItem(
    "user",
    JSON.stringify({ ...user, clientUserProfilePicture: clientUserProfilePicture?.path, clientProfilePicture: clientProfilePicture?.path })
  );
  localStorage.removeItem("permissions");
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("expiresIn", expiresIn);
};

export const expiredSessionHelper = () => {
  alert("You have been logged out due to inactivity.");
  logoutHelper();
  window.location.href = "/";
};